"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cache_1 = require("./cache");
exports.useDebounce = cache_1.default;
var callback_1 = require("./callback");
exports.useDebouncedCallback = callback_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/use-debounce/lib/index.js
// module id = 2675
// module chunks = 0